// extracted by css-extract-rspack-plugin
export default {"removeButton":"gYE0k","bookmark":"alId4"};